import React from "react";

const ContactUsBlockMobile = () => {
  return (
    <>
      <div className="shadow-xl grid grid-cols-1 rounded-xl  bg-white">
        <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 lg:p-12">
              <h3 className="text-2xl sm:text-3xl font-bold text-center text-gray-900">
                Contact Information
              </h3>
              <p className="mt-2 text-base sm:text-lg text-gray-600 text-center max-w-xl mx-auto">
                Fill up the form and our team will get back to you shortly.
              </p>



                  {/* Contact Form */}
              <div className="bg-white py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
              <div className="max-w-4xl mx-auto">
                <form
                  action="https://formspree.io/f/mzbqdzwv"
                  method="POST"
                  autoComplete="off"
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="fname" className="text-gray-700 font-medium block">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="fname"
                        id="fname"
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                        placeholder="Your first name"
                        required
                      />
                    </div>

                    <div className="space-y-2">
                      <label htmlFor="lname" className="text-gray-700 font-medium block">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="lname"
                        id="lname"
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                        placeholder="Your last name"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 sm:mt-4 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="email" className="text-gray-700 font-medium block">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                        placeholder="your@email.com"
                        required
                      />
                    </div>

                    <div className="space-y-2">
                      <label htmlFor="tel" className="text-gray-700 font-medium block">
                        Phone
                      </label>
                      <input
                        type="tel"
                        name="tel"
                        id="tel"
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                        placeholder="+91 98765 43210"
                      />
                    </div>
                  </div>

                  <div className="space-y-2 mt-6">
                    <label htmlFor="message" className="text-gray-700 font-medium block">
                      Message
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      rows="6"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none"
                      placeholder="Tell us about your project, timeline, or questions..."
                      required
                    ></textarea>
                  </div>

                  <div className="flex justify-center pt-6">
                    <button
                      type="submit"
                      className="group px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-tertiary to-primary text-white rounded-full font-semibold text-base sm:text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25 flex items-center gap-2"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ContactUsBlockMobile;
